/* @flow */

import _ from 'lodash';

export const getAllIntelligenceProgressByChild = (state: Object, child_id) => (_.get(state.intelligence_progress, [child_id], []));

export const getIntelligenceProgressById = (state, intelligence_id) => (_.find(state.intelligence_progress, { intelligence_id: intelligence_id }) || {});

export const getIntelligenceHistory = (state, child_id, intelligence_id) => (_.get(state.intelligence_history, [child_id, intelligence_id], null));
